if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    #current = 0;
    #interval = undefined;
    connectedCallback() {
      this.addEventListener('mouseenter', this.suspend);
      this.addEventListener('mouseleave', this.resume);
      if(this.prevButton) this.prevButton.addEventListener('click', this.previous.bind(this));
      if(this.nextButton) this.nextButton.addEventListener('click', this.next.bind(this));
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      this.play();
    }

    get current() {
      return this.#current;
    }

    set current(current) {
      this.#current = current;
  
      let relativeIndex = current % (this.refs.slides ?? []).length;
      if (relativeIndex < 0) {
        relativeIndex += (this.refs.slides ?? []).length;
      }
  
      this.refs.slides?.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', `${index !== relativeIndex}`);
      });
    }

    get autoplayInterval() {
      const interval = this.getAttribute('autoplay');
      const value = parseInt(`${interval}`, 10);
      if (Number.isNaN(value)) return undefined;
      return value * 1000;
    }

    get autoplay() {
      return Boolean(this.autoplayInterval);
    }

    get refs() {
      return {
        slides: this.querySelectorAll('[data-announcement-slide]'),
      };
    }

    get prevButton() {
      return this.querySelector('[data-action="previous"]');
    }

    get nextButton() {
      return this.querySelector('[data-action="next"]');
    }

    next() {
      this.current += 1;
    }
  
    previous() {
      this.current -= 1;
    }

    play(interval = this.autoplayInterval) {
      if (!this.autoplay) return;
  
      this.paused = false;
  
      this.#interval = setInterval(() => {
        if (this.matches(':hover') || document.hidden) return;
  
        this.next();
      }, interval);
    }

    pause() {
      this.paused = true;
      this.suspend();
    }

    suspend() {
      clearInterval(this.#interval);
      this.#interval = undefined;
    }

    resume() {
      if (!this.autoplay || this.paused) return;
  
      this.pause();
      this.play();
    }

    handleVisibilityChange = () => (document.hidden ? this.pause() : this.resume());
  }
  customElements.define('announcement-bar', AnnouncementBar);
}